import { List } from "antd";
import { EditOutlined, WarningOutlined, StopOutlined } from "@ant-design/icons";
import { get, toString } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paginationDefaults } from "../../../utils/properties";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Filter from "../../../components/functional_components/Filter/Filter";
import { useFormik } from "formik";
import { buildQueryString, showError } from "../../../utils/utilities";
import { setFilters } from "../../../redux/ducks/Filters";
import OrderAllocation from "../../../services/api/OrderAllocation";
import { setLoading } from "../../../redux/ducks/Loading";

const OdaAllocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    costCentersList: [],
    tableContent: [],
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
  });
  useEffect(() => {
    getCostCentersOptions();
    const queryString = buildQueryString(filters.obj, { status: "OPEN" });
    dispatch(setFilters(queryString));
    dataList(queryString.string);
  }, []);

  const dataList = async (queryString) => {
    dispatch(setLoading(true));
    const odaSuppliers = await OrderAllocation.listOdaAllocationSuppliers(queryString);
    if (!odaSuppliers.error && odaSuppliers.data) {
      odaSuppliers.data.forEach((cc, i) => {
        cc.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        tableContent: get(odaSuppliers, "data", []),
        pagination: {
          currentPage: odaSuppliers.currentPage ? odaSuppliers.currentPage + 1 : paginationDefaults.page,
          size: get(odaSuppliers, "pageSize", paginationDefaults.size),
          totalItems: get(odaSuppliers, "totalItems", paginationDefaults.totalItems),
        },
      }));
    } else {
      showError(get(odaSuppliers, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };
  const formikFilter = useFormik({
    initialValues: {
      costCentreId: filters.obj.costCentreId ? filters.obj.costCentreId : null,
      status: filters.obj.status ? filters.obj.status : null,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      // When I search, I start my page to 0
      values["page"] = 0;
      const queryString = buildQueryString(filters.obj, values);
      dispatch(setFilters(queryString));
      dataList(queryString.string);
    },
  });

  const resetFilter = () => {
    const queryString = buildQueryString(
      {
        page: toString(paginationDefaults.page - 1),
        size: toString(paginationDefaults.size),
      },
      {}
    );
    dispatch(setFilters(queryString));
    dataList(queryString.string);
  };

  const getCostCentersOptions = async () => {
    const costCenters = await OrderAllocation.listOdaCostCentersByUser();
    if (!costCenters.error && costCenters.data) {
      let dataForSelect = [];
      costCenters.data.forEach((el) => {
        dataForSelect.push({ label: el.id, value: el.id });
      });
      setState((prevState) => ({
        ...prevState,
        costCentersList: dataForSelect,
      }));
    } else {
      showError(get(costCenters, "error.messageCode", "ER000"));
    }
  };

  const fieldsFilter = [
    {
      type: "select",
      isRequired: false,
      id: "costCentreId",
      name: "costCentreId",
      value: formikFilter.values.costCentreId,
      label: t("projects.detail.costCentre"),
      onChange: formikFilter.handleChange("costCentreId"),
      onBlur: formikFilter.handleBlur,
      dataSelect: state.costCentersList,
    },
    {
      type: "select",
      isRequired: false,
      id: "status",
      name: "status",
      value: formikFilter.values.status,
      label: t("general.status"),
      onChange: formikFilter.handleChange("status"),
      onBlur: formikFilter.handleBlur("status"),
      dataSelect: [
        {
          label: t("odaAllocation.filter.all"),
          value: "",
        },
        {
          label: t("odaAllocation.filter.completed"),
          value: "COMPLETED",
        },
        {
          label: t("odaAllocation.filter.open"),
          value: "OPEN",
        },
      ],
    },
  ];
  return (
    <>
      <Filter formikForm={formikFilter} fields={fieldsFilter} onReset={resetFilter} />
      <List
        header={<strong>{t("userSupplier.suppliers")}</strong>}
        bordered
        size="small"
        pagination={{
          size: "small",
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            const queryString = buildQueryString(filters.obj, {
              page: toString(page - 1),
              size: pageSize,
            });
            dispatch(setFilters(queryString));
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(queryString.string);
          },
        }}
        dataSource={state.tableContent}
        renderItem={(item) => (
          <List.Item
            actions={[
              <div
                className="list-actions"
                key={item.id + "-" + Math.random()}
                onClick={() => navigate(`${item.id}`, { state: { supplierName: item.name } })}
              >
                <EditOutlined className="icon-medium" />
              </div>,
            ]}
          >
            <List.Item.Meta
              title={
                <div>
                  {item.alert && <WarningOutlined key={item.id + "-" + Math.random()} className="PFred mr-10" />}
                  {item.orderBlocked && <StopOutlined key={item.id + "-" + Math.random()} className="PFred mr-10" />}
                  {`${item.id} | ${item.name}`}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </>
  );
};

export default OdaAllocation;
